import { createResourceKeys } from "@/lib/resource-context";

export const toolsKeys = createResourceKeys("tools");
